import { render, staticRenderFns } from "./CreatePasswordForm.vue?vue&type=template&id=12b87126"
import script from "./CreatePasswordForm.vue?vue&type=script&lang=js"
export * from "./CreatePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./CreatePasswordForm.vue?vue&type=style&index=0&id=12b87126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports